export default "__VITE_ASSET__Oe1xvAUP__"